// extracted by mini-css-extract-plugin
export default {"subtitleBr":"r3CQ6"};